import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import FixedHeightWrapper from 'app/meets/FixedHeightWrapper';
import { getLifterAwardsWeightClassDoc } from 'util/lifterHelper';
import TeamResultsTable from './TeamResultsTable';

import {
  getCurrentMeet,
  getScreenMedia
} from 'selectors';

import './TeamIndex.scss';

class TeamIndex extends Component {
  shouldDisplayRow = (lifter) => {
    return lifter.team === this.getTeamName();
  }

  getTeamName = () => {
    return decodeURIComponent(this.props.match.params.teamName);
  }

  render() {
    const {
      meet,
      media
    } = this.props;

    const teamName = this.getTeamName();

    const teamLifters = _.filter(meet.lifters, {team: teamName});
    const divisions = _.filter(meet.divisions, (division) => {
      return _.find(teamLifters, (lifter) => {
        return _.find(lifter.divisions, {divisionId: division._id});
      });
    });

    const divisionsAndWeightClasses = _.map(divisions, (division) => {
      const weightClasses = _.filter(division.weightClasses, (wc) => {
        return _.find(teamLifters, (lifter) => {
          return _.find(lifter.divisions, (ld) => {
            return ld.divisionId === division._id && getLifterAwardsWeightClassDoc(meet, lifter, ld)._id === wc._id;
          });
        });
      });
      return {...division, weightClasses};
    });

    return (
      <FixedHeightWrapper>
        <div className="team-index">
          <div className="team-name">{teamName}</div>
          <div className="table-wrapper">
            <TeamResultsTable meet={meet} divisions={divisionsAndWeightClasses} media={media} shouldDisplayRow={this.shouldDisplayRow} />
          </div>
        </div>
      </FixedHeightWrapper>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    meet: getCurrentMeet(state, props),
    media: getScreenMedia(state, props)
  };
};

const actions = {};

export default connect(mapStateToProps, actions)(TeamIndex);
